module.exports = __webpack_public_path__ + "static/media/header-mail-preview.96a84859.png";